import React from "react";
import ConfirmAdvise from "@components/ui/ConfimDialogueAdvise";
import AdviseModal from "@components/common/Modals/AdviseModal";
import { useTranslation } from "react-i18next";

const AdviseSection = ({
  isAdviseOpen,
  setIsAdviseOpen,
  automaticTargetWeight,
  goalBodyFat,
  goalWaistCircumference,
  message,
  automaticTimeline,
  automaticDurationType,
  handleApplyGoal,
  automaticTargetWeightUnit,
  maintenanceCalories,
  targetDailyCalories,
  dailyCalorieAdjustment,
  open,
  handleClose,
  isAdviceLoading,
  selectedTags,
  setCurrentStep,
  dynamicOptions,
  suggestedWorkouts,
  suggestedEquipment,
  suggestedDifficulty,
  setSuggestedWorkouts,
  setSuggestedEquipment,
  setSuggestedDifficulty,
  dailyExerciseTimePreference,
  selectableDays,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <AdviseModal
        showModal={isAdviseOpen}
        setShowModal={setIsAdviseOpen}
        targetWeight={automaticTargetWeight}
        message={message}
        timeline={automaticTimeline}
        durationType={automaticDurationType}
        handleApplyGoal={handleApplyGoal}
        targetWeightUnit={automaticTargetWeightUnit}
        maintenanceCalories={maintenanceCalories}
        targetDailyCalories={targetDailyCalories}
        dailyCalorieAdjustment={dailyCalorieAdjustment}
        goalBodyFat={goalBodyFat}
        goalWaistCircumference={goalWaistCircumference}
        dynamicOptions={dynamicOptions}
        suggestedWorkouts={suggestedWorkouts}
        suggestedEquipment={suggestedEquipment}
        suggestedDifficulty={suggestedDifficulty}
        setSuggestedWorkouts={setSuggestedWorkouts}
        setSuggestedEquipment={setSuggestedEquipment}
        setSuggestedDifficulty={setSuggestedDifficulty}
        dailyExerciseTimePreference={dailyExerciseTimePreference}
        selectableDays={selectableDays}
      />
      <ConfirmAdvise
        open={open}
        handleClose={handleClose}
        isLoading={isAdviceLoading}
        selectedTags={selectedTags}
        setCurrentStep={setCurrentStep}
        heading={t("firstFormSteps.confirmAdviseHeading")}
        message={<>{t("firstFormSteps.confirmAdviseDescription")}</>}
        adviseMe={false}
      />
    </>
  );
};

export default AdviseSection;
